import { fg } from '@confluence/feature-gating';

// Most queries will use AGG once cc-agg-migration-use-agg-endpoint is fully rolled out
// We are migrating Activity V3 queries for custom domain tenants earlier due to a cc-graphql bug
// This should be removed during the cleanup of cc-agg-migration-use-agg-endpoint
export const shouldUseAGGActivityV3 = () => {
	const isDefaultDomain =
		window.location.hostname.endsWith('.atlassian.net') ||
		window.location.hostname.endsWith('.jira-dev.com');

	return !isDefaultDomain && fg('cc-activity-v3-use-agg-endpoint-for-custom-domain');
};
